<template>
  <div>
    <div class="flex">
      <span class="font-700 mr-1 mt-[2px]">{{ $t('evaluate.agent_tools') }}</span>
    </div>
    <template v-if="payloadData.tools.length">
      <div v-for="(evaluateItem, index) in payloadData.tools" :key="`parallel-${index}`">
        <EvaluateDropZone v-if="index === 0" :accept="acceptList" :evaluate="evaluate" :parent-id="item.id" :index="index" @evaluate-update="$emit('evaluate-update', $event)" />
        <EvaluateItem
          :evaluate="evaluate"
          :selectedEvaluateItemId="selectedEvaluateItemId"
          :item="evaluateItem"
          @update="onEvaluateItemUpdated($event, index)"
          @item-click.stop="onItemClick"
          @evaluate-update="$emit('evaluate-update', $event)"
        />
        <EvaluateDropZone :accept="acceptList" :evaluate="evaluate" :parent-id="item.id" :index="index + 1" evaluate-key="else" @evaluate-update="$emit('evaluate-update', $event)" />
      </div>
    </template>
    <template v-else>
      <EvaluateDropZone :accept="acceptList" :evaluate="evaluate" :parent-id="item.id" :index="0" zero-state="Drag & Drop agent tools here" @evaluate-update="$emit('evaluate-update', $event)" />
    </template>
  </div>
</template>

<script>
import EvaluateDropZone from './EvaluateDropZone';

export default {
  name: 'AIAgentOverview',
  components: { EvaluateDropZone },
  props: {
    item: Object,
    evaluate: Array,
    selectedEvaluateItemId: String,
  },
  data() {
    return {
      payloadData: null,
      acceptList: [
        'ChartOverview',
        'DataAnalysisOverview',
        'DataAdapterOverview',
        'ApiOverview',
        'ActionApiOverview',
        'EmailOverview',
        'ActionEmailOverview',
        'DocumentHTMLOverview',
        'DocumentImageOverview',
        'DocumentPDFOverview',
        'ActionScheduleOverview',
        'ResponseOverview',
        'DataTransformOverview',
        'FlowInvokeOverview',
      ],
    };
  },
  computed: {
    payload() {
      return this.item.payload;
    },
  },
  methods: {
    onItemClick($event, evaluateItem) {
      this.$emit('item-click', $event, evaluateItem);
    },
    onEvaluateItemUpdated(evaluateItem, evaluateIndex) {
      this.payloadData.tools[evaluateIndex] = evaluateItem;
      this.$emit('update', this.payloadData);
    },
  },
  watch: {
    payload: {
      handler() {
        this.payloadData = JSON.parse(JSON.stringify(this.payload));
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
